import { Inject, Injectable } from '@angular/core';
import { DwEventService, DwOrmDataService, DwOrmDataServiceToken, DwSecurityUserService } from '@devwareapps/devware-cap';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, shareReplay, startWith, switchMap, take } from 'rxjs/operators';
import { AppMetaData, AppearancePresetEntity } from '../../../../meta-data/app-meta-data.service';

/** One session catalog shared by cards/editors; CAP applies tenant and read permissions. */
@Injectable({ providedIn: 'root' })
export class AppearancePresetsService {
    private refresh = new BehaviorSubject<void>(undefined);
    readonly failed$ = new BehaviorSubject<boolean>(false);
    readonly presets$: Observable<AppearancePresetEntity[]>;
    constructor(@Inject(DwOrmDataServiceToken) private orm: DwOrmDataService, security: DwSecurityUserService, events: DwEventService) {
        this.presets$ = this.refresh.pipe(switchMap(() => {
            this.failed$.next(false);
            return this.load().pipe(catchError(() => { this.failed$.next(true); return of(null); }), startWith(null));
        }),
            shareReplay({ bufferSize: 1, refCount: true }));
        security.securityContextChanged().subscribe(() => this.reload());
        events.getEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaData.AppearancePreset.ItemDetail.itemName))
            .subscribe(() => this.reload());
    }
    reload(): void { this.refresh.next(); }
    private load(): Observable<AppearancePresetEntity[]> {
        const query = AppMetaData.AppearancePreset.CreateQueryBuilder().addOrderBy(a => a.SortOrder).addOrderBy(a => a.Name);
        return this.orm.executeQuery<AppearancePresetEntity>(query).pipe(take(1));
    }
}
